(function () {
    "use strict";

    angular.module("app").filter("ScreeningStyleSelector", FilterFactory);

    FilterFactory.$inject = ["enumService",];
    function FilterFactory(enumService) {
        return function (line, filterStatus) {
            const defaultClasses = "fvm-screening-row";

            if (!line)
                return defaultClasses;

            return `${defaultClasses} ${getClass(line, filterStatus)}`;
        };

        function getClass(line, filterStatus) {
            const screening = line.Screening;

            if (screening) {
                const result = parseInt(screening.ResultCode);
                const status = parseInt(screening.Status);

                if (status === enumService.ScreeningStatusCode.ReadOnly)
                    return "bg-success";

                if (!line.IsStillValid && (status === enumService.ScreeningStatusCode.Accepted || status === enumService.ScreeningStatusCode.New))
                    return "screeningOutOfTimeLimit";

                if ((screening.Status !== filterStatus))
                    return "bg-warning screening-incomplete";

                if (result === enumService.ScreeningResultCode.Retour)
                    return "retour";

                if (parseInt(filterStatus) === enumService.ScreeningStatusCode.Accepted) {
                    if (screening.TypeCode === enumService.ScreeningTypeCode.FVM)
                        return "bg-success";
                }

                if (line.IsForeign)
                    return "panel-Foreign bg-Foreign";

                return "";
            }

            return line.Type.toLowerCase() === "individual" ? "" : "lavender";
        } 
    }
})();